/**
 * Canonical GraphDocument schema version (SPEC-001 REQ-057).
 *
 * This constant exists ahead of the full Funnel Domain (SPEC-004+) so that
 * persistence and serialization code can reference a single source of
 * truth from the start. See docs/architecture/graph-schema.md for the
 * canonical GraphDocument contract that owns this value going forward.
 */
export const FUNNEL_SCHEMA_VERSION = 1 as const;
